import React from "react";
import moment from "moment";

export default function LedgerCard({ item }) {
  const isDeposit = item.deposit > 0;
  const isWithdraw = item.withdraw > 0;
  const isCredit = item.credit > 0;
  const isWeekly = item.weekly_amt !== 0;

  const amount =
    item.deposit || item.withdraw || item.credit || item.weekly_amt || 0;

  const type = isDeposit
    ? "Deposit"
    : isWithdraw
    ? "Withdraw"
    : isCredit
    ? "Credit"
    : isWeekly
    ? "Weekly"
    : "Transaction";

  const color =
    isDeposit || isCredit || isWeekly ? "text-[var(--buy)]" : "text-[var(--sellmeta)]";

  return (
    <div className="border-2 border-[var(--hover)] rounded-lg p-3 mb-2 flex justify-between items-center bg-[var(--background)] shadow-sm transition-all">
      {/* Left Section */}
      <div>
        <p className="text-sm font-semibold text-[var(--text)]">
          {type}
        </p>
        {item.comment && (
          <p className="text-xs text-[var(--subtext)]">
            {item.comment}
          </p>
        )}
        {item.remarks && (
          <p className="text-[11px] text-[var(--subtext)]">
            {item.remarks}
          </p>
        )}
        <p className="text-[11px] text-[var(--subtext)] mt-1">
          {moment(item.date_created).format("DD MMM YYYY, hh:mm A")}
        </p>
      </div>

      {/* Right Section */}
      <div className={`text-sm font-semibold ${color}`}>
        ₹{amount.toLocaleString("en-IN")}
      </div>
    </div>
  );
}
